module.exports = __webpack_public_path__ + "img/29.5.COD.689a6f2e.png";